<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M1.82,22.886c-0.605,0-1.173-0.235-1.6-0.662C0.078,22.082,0,21.894,0,21.694s0.078-0.389,0.22-0.53
		c0.141-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22c0.144,0.144,0.335,0.223,0.539,0.223c0.204,0,0.396-0.079,0.54-0.223
		l1.17-1.17c0.197-1.222,0.028-2.456-0.492-3.576c-0.009-0.019-0.016-0.037-0.023-0.055c-1.495-4.069-0.938-7.218,1.755-9.91
		c1.797-1.798,3.976-2.748,6.303-2.748c0.088,0,0.177,0.001,0.265,0.004c1.764,0.056,3.515,0.675,5.087,1.795
		c0.654-0.798,0.745-1.575,0.772-2.914c0.01-0.408,0.177-0.784,0.468-1.062c0.281-0.267,0.652-0.414,1.045-0.414
		c0.002,0,1.363,0.033,1.363,0.033c0.813,0.021,1.473,0.7,1.47,1.513c0.035,0.544,0.011,1.108-0.071,1.67
		c0.495,0.032,0.98,0.128,1.447,0.285c0.746,0.198,1.223,1.006,1.039,1.795l-0.323,1.31c-0.096,0.391-0.339,0.72-0.684,0.928
		c-0.236,0.142-0.504,0.217-0.776,0.217l0,0c-0.122,0-0.245-0.015-0.364-0.045c-0.026-0.006-0.059-0.016-0.083-0.025
		c-0.337-0.125-0.687-0.189-1.041-0.189c-0.398,0-0.792,0.081-1.158,0.235c0.835,1.389,1.299,2.903,1.346,4.403
		c0.076,2.427-0.873,4.7-2.745,6.573c-1.723,1.725-3.636,2.564-5.847,2.564c-1.252,0-2.579-0.264-4.057-0.808
		c-0.022-0.009-0.04-0.016-0.058-0.024c-0.817-0.38-1.684-0.573-2.578-0.573c-0.333,0-0.67,0.028-1.003,0.082l-1.166,1.167
		C2.994,22.651,2.425,22.886,1.82,22.886z M8.772,20.175c1.309,0.479,2.46,0.712,3.519,0.712c1.808,0,3.326-0.677,4.778-2.131
		c1.572-1.572,2.369-3.462,2.306-5.465c-0.062-1.956-0.976-3.914-2.574-5.511c-1.598-1.598-3.555-2.512-5.511-2.573
		c-0.074-0.002-0.147-0.003-0.221-0.003c-1.918,0-3.73,0.798-5.24,2.309c-2.255,2.255-2.693,4.816-1.419,8.303
		c0.53,1.155,0.764,2.416,0.686,3.673c0.163-0.01,0.326-0.016,0.488-0.016C6.687,19.472,7.76,19.708,8.772,20.175z M17.584,6.451
		c0.099,0.092,0.191,0.181,0.278,0.267c0.226,0.226,0.444,0.463,0.651,0.708c0.575-0.692,1.008-1.5,1.265-2.361
		c0.005-0.11,0.034-0.217,0.086-0.315c0.164-0.668,0.225-1.352,0.181-2.035c-0.001-0.02-0.002-0.042-0.001-0.064l-1.339-0.039
		c-0.004,0-0.005,0.001-0.006,0.002C18.667,4.092,18.565,5.256,17.584,6.451z M20.683,7.105c0.507,0,1.007,0.085,1.487,0.254
		l0.33-1.3c-0.008-0.002-0.03-0.015-0.038-0.018c-0.432-0.146-0.887-0.219-1.351-0.219c-0.001,0-0.001,0-0.002,0
		c-0.153,0.445-0.344,0.875-0.57,1.285C20.588,7.105,20.636,7.105,20.683,7.105z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'vegetables-beet-1',
    },
    name: {
      type: String,
      required: false,
      default: 'VegetablesBeet1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>